import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Tab, Tabs } from '@blueprintjs/core';
import Iframe from 'react-iframe'
import './Multivar.css';

class Pca extends React.PureComponent {

  state = {
    selectedTabId:'widget1'
  }


  handleTabChange = (navbarTabId) => this.setState({ selectedTabId: navbarTabId });

  render() {
    const { varPlotUrl, indPlotUrl, t } = this.props;
    const varPlot= <Iframe className='iframe' url={varPlotUrl} />;
    const indPlot=  <Iframe className='iframe' url={indPlotUrl} />;

    return (
        <Tabs onChange={this.handleTabChange} selectedTabId={this.state.selectedTabId}>
          { varPlotUrl && <Tab id='widget1' title={t('widget1')} panel={varPlot}/> }
          { indPlotUrl && <Tab id='widget2' title={t('widget2')} panel={indPlot}/> }
        </Tabs>
    );
  }
}

Pca.propTypes = {
    varPlotUrl: PropTypes.string,
    indPlotUrl: PropTypes.string,
};

export default withTranslation()(Pca);
